import { Path } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function PencilIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Path d="M15.5 4.5l4 4L9 19l-5 1 1-5z" />
      <Path d="M13.5 6.5l4 4" />
    </LineIcon>
  );
}
